import customaxios from ".";
import qs from "qs";

export const getProviderList = (
  serviceCategoryId: number,
  type: string,
  userLat: number,
  userLng: number,
  userName: string,
  phoneNumber: string,
  page?: number,
  pageSize?: number
) => {
  return customaxios({
    method: "GET",
    url: `/provider/find-list`,
    params: {
      serviceCategoryId: serviceCategoryId,
      type: type,
      userLat: userLat,
      userLng: userLng,
      userName: userName,
      phoneNumber: phoneNumber,
      page: page,
      pageSize: pageSize,
    },
  });
};

export const getServices = (typeOfService: string) => {
  return customaxios({
    method: "GET",
    url: "/services",
    params: {
      type: typeOfService,
    },
  });
};

export const getInitialProviders = (params: any) => {
  return customaxios({
    method: "GET",
    url: "/provider/filter-list",
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getFilteredProviders = (params: any) => {
  return customaxios({
    method: "GET",
    url: "/provider/filter-list",
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const toggleProviderFavorite = (providerId: number) => {
  return customaxios({
    method: "POST",
    url: `/provider/favorite/${providerId}`,
  });
};
export const requestProviderQuote = (providerId: number, data: any) => {
  return customaxios({
    method: "POST",
    url: `/provider/${providerId}/request-quote`,
    data,
  });
};
